import React from "react";
import PropTypes from "prop-types";
import { withSize } from "react-sizeme";
import { isValidValue } from "utils/validators";
import styles from "components/grid/cell-formatters/focus-cell-formatters.scss";
import { paymentTypeType } from "custom-prop-types";

export const PaymentTypeCell = ({ documentCount, rowIndex, size, value }) => {
  if (!isValidValue(value)) {
    return <div>Other</div>;
  }

  let newValue = value;
  if (typeof value === "string") {
    newValue = JSON.parse(value);
  }

  let length = newValue.type ? newValue.type.length * 5 : 0;
  length = newValue.lastFourDigits ? length += newValue.lastFourDigits.length * 5 : length;
  const tooltipStyle = rowIndex < (documentCount / 2) ? styles["tooltip-bottom"] : styles["tooltip-top"];
  return (
    <div className={ styles.container }>
      { renderValue(newValue) }
      { renderTooltip(length, size, newValue, tooltipStyle) }
    </div>
  );
};

PaymentTypeCell.defaultProps = {
  value: {}
};

PaymentTypeCell.propTypes = {
  documentCount: PropTypes.number.isRequired,
  rowIndex: PropTypes.number.isRequired,
  size: PropTypes.shape({ size: PropTypes.number }).isRequired,
  value: paymentTypeType
};

export const PaymentTypeCellFormatter = withSize()(PaymentTypeCell);

const renderTooltip = (length, size, value, tooltipStyle) => {
  if (length > size.width) {
    return (
      <div className={ tooltipStyle }>
        { renderValue(value) }
      </div>
    );
  }
  return null;
};

const renderValue = (newValue) => {
  switch (newValue.type) {
    case "credit-card":
      return <div>Credit card {newValue.lastFourDigits ? `(${newValue.lastFourDigits})` : ""}</div>;
    case "cash":
      return <div>Cash</div>;
    case "cheque":
    case "check":
      return <div>Cheque</div>;
    case "paypal":
      return <div>PayPal</div>;
    default:
      return <div>Other</div>;
  }
};



// WEBPACK FOOTER //
// ./src/js/components/grid/cell-formatters/payment-type-cell-formatter.jsx